class FiniteStateMachine {
    animationController;
    states;
    currentState;
    /**
     * A finite state machine handling the transition between animation states.
     * @param states The animation states to handle between.
     * @param animationController The entity's animation controller.
     */
    constructor(states, animationController) {
        this.states = states;
        this.animationController = animationController;
        this.currentState = null;
    }
    /**
     * Set the state to one matching the name.
     * @param name The name of the state to change to.
     */
    setState(name) {
        const previousState = this.currentState;
        if (previousState) {
            if (previousState.name === name)
                return;
            previousState.exit();
        }
        this.currentState = this.states[name];
        this.currentState.enter(previousState || undefined);
    }
    /**
     * Perform an update on the current animation state.
     * @param deltaTime The interval in seconds from the last frame to the current one.
     * @param input A character input controller.
     */
    update(deltaTime, input) {
        if (!this.currentState)
            return;
        this.currentState.update(deltaTime, input, name => this.setState(name));
        this.animationController.update(deltaTime);
    }
}
export default FiniteStateMachine;
